import { Icon } from './icons';

/**
 * Message d'un formulaire (ADR-092) : un **emplacement réservé** dès l'affichage (région
 * `aria-live="polite"`, hauteur d'une à deux lignes) où un échec s'affiche en bandeau du design
 * system (`role="alert"`, icône, jetons `status.danger*`) sans déplacer la page. Le texte principal
 * n'est jamais un code technique : celui-ci ne va qu'au détail repliable.
 */
export function FormMessage({ message, detail, detailLabel = 'Détail technique' }: { message: string | null; detail?: string | undefined; detailLabel?: string }) {
  return (
    <div className="ay-form__message" aria-live="polite" data-testid="form-message">
      {message !== null && (
        <div className="ay-alert ay-alert--danger" role="alert">
          <Icon name="alert" size={16} />
          <div>
            <span className="ay-alert__text">{message}</span>
            {detail !== undefined && (
              <details>
                <summary>{detailLabel}</summary>
                <code>{detail}</code>
              </details>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
